<template>
  <div class="overflow-hidden">
    <div class="float-left overflow-hidden">
      <a-upload-dragger
        class="avatar-uploader"
        :before-upload="beforeUpload"
        :customRequest="api"
        :show-upload-list="false"
        :accept="accept"
        :disabled="disabled"
      >
        <div
          v-if="imgsrc"
          class="h-32"
          :style="{
            backgroundImage: `url(${$ossUrl}${imgsrc})`,
            backgroundPosition: 'center center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
          }"
        />
        <!-- <img
          v-if="imgsrc"
          :src="$ossUrl + imgsrc"
          alt="avatar"
          class="h-full"
          style="max-width: 100% !important; height: auto !important"
        /> -->
        <div v-else>
          <a-icon type="loading" v-if="loading" />
          <a-icon type="plus" v-else />
          <div class="ant-upload-text">上传</div>
        </div>
      </a-upload-dragger>
    </div>
    <div
      v-if="!disabled"
      class="float-left w-8 px-1 leading-8 text-center text-white bg-blue-700 rounded-r cursor-pointer hover:bg-blue-800"
      style="height: 128px"
      @click="getQrcode"
    >
      扫码上传
    </div>
    <a-modal
      title="扫码上传"
      :visible="qrcodeFlag"
      :footer="null"
      @cancel="qrcodeFlag = false"
      forceRender
    >
      <div class="m-auto my-4"> 您可通过手机扫描下方二维码快捷上传对应的材料 </div>
      <div class="m-auto">
        <div id="qrcode" ref="qrcode"></div>
      </div>
    </a-modal>
  </div>
</template>
<script>
  import { v4 as uuidv4 } from 'uuid';
  import QRCode from 'qrcodejs2';
  import { resourceByUUID } from '@/api/resource';

  export default {
    props: {
      accept: {
        default: 'image/*',
        type: String,
      },
      src: String,
      disabled: Boolean,
    },
    data() {
      return {
        imgsrc: '',
        loading: false,
        uuid: '',
        qrcodeUrl: '',
        qrcodeFlag: false,
        qrcode: '',
        timer: null,
      };
    },
    mounted() {
      this.imgsrc = this.src;
    },
    watch: {
      qrcodeFlag(a) {
        if (a) {
          this.timer = setInterval(async () => {
            if (this.uuid) {
              let data = await resourceByUUID(this.uuid);
              if (data.pathname != '') {
                clearInterval(this.timer);
                this.qrcodeFlag = false;
                this.$emit('upload', data);
              }
            }
          }, 1000);
        } else {
          if (this.timer) {
            clearInterval(this.timer);
          }
        }
      },
      src(a) {
        this.imgsrc = a;
      },
    },
    methods: {
      beforeUpload(file) {
        const isLt = file.size / 1024 / 1024 < 50;
        if (!isLt) {
          this.$message.error('上传文件需小于50MB!');
          return false;
        }
        return isLt;
      },
      async api(e) {
        let formData = new FormData();
        formData.append('file', e.file);
        formData.append('where', 'license');
        formData.append('style', '1');
        this.loading = true;
        let res = await this.$uploadfile('/api/v1/file_upload', formData);
        this.imgsrc = res.pathname;
        this.$emit('upload', res);
        this.loading = false;
      },
      getQrcode() {
        this.uuid = uuidv4();
        this.qrcodeUrl =
          'https://' + window.location.host + '/api/v1/upload_file_by_qr/' + this.uuid;
        // this.qrcodeUrl = 'http://192.168.28.73:9091' + '/api/v1/upload_file_by_qr/' + this.uuid;
        if (this.qrcode) {
          this.$refs['qrcode'].innerHTML = '';
        }
        this.qrcode = new QRCode(this.$refs['qrcode'], {
          text: this.qrcodeUrl,
          width: 300,
          height: 300,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H,
        });
        this.qrcodeFlag = true;
      },
    },
  };
</script>
<style lang="less">
  .avatar-uploader {
    .ant-upload {
      width: 128px;
      height: 128px;
      margin-bottom: 0 !important;
    }
  }
</style>
<style scoped>
  :deep(.ant-upload-btn) {
    padding: 0 !important;
  }
</style>
